import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import sal from "sal.js";
import EnquiryForm from "../../Components/EnquiryForm";

export default function AiChatbot(){
    useEffect(() => {
        sal();
    }, []);
    return(
        <>
            <section className="banner-bg bg-dark control-panel-banner slash-banner-part">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-7 col-xl-7">
                            <span className="fs-18 fw-semibold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                AI Chatbot Assistance
                            </span>
                            <h1 className="text-white mb-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                AI Chatbot? Yeah!! Because Everyone Wants an Instant Reply
                            </h1>
                            <p className="mb-8 text-white max-text-72 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Users scroll, explore, hesitate… & sometimes leave, even without saying a word. An AI chatbot welcomes and answers quickly, turning hesitant visits into meaningful conversations.</p>
                        </div>
                        <div className="col-lg-5 col-xl-5 ipad-mt">
                            <EnquiryForm/>
                        </div>
                    </div>
                </div>
            </section>

            <section className="service-area pt-100 pb-40">
                <div className="pb-40">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-7">
                                <span className="d-block text-primary fs-18 fw-bold mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Absence of a Chatbot!</span>
                                <h2 className="mb-0 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">When a Visitor is Waiting… But There Was No Chatbot</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row g-4">
                        <div className="col-lg-6 col-xl-4">
                            <div className="card service-card-item shadow-sm rounded-3 h-100 sal-animate" data-sal="slide-up" data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                                <div className="card-body px-md-7 py-md-8">
                                    <h6>Slow Replies?</h6>
                                    <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                        <div>
                                            <img src="images/slow-replies.webp" alt="" />
                                        </div>
                                        <div>
                                            <p>Visitors always expect answers in a blink. When responses take too long, curiosity fades, and customers generally move on to brands that reply quickly.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-4">
                            <div className="card service-card-item shadow-sm rounded-3 h-100 sal-animate" data-sal="slide-up" data-sal-duration="450" data-sal-delay="150" data-sal-easing="ease-in-out-sine">
                                <div className="card-body px-md-7 py-md-8">
                                    <h6>Lost Leads?</h6>
                                    <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                        <div>
                                            <img src="images/lost-leads.webp" alt="" />
                                        </div>
                                        <div>
                                            <p>Every customer checking out your site could become a potential visitor. With the absence of a chatbot engaging them perfectly, all opportunities just slip away.</p>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-4">
                            <div className="card service-card-item shadow-sm rounded-3 h-100 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                                <div className="card-body px-md-7 py-md-8">
                                    <h6>Support Overload?</h6>
                                    <div className="d-flex flex-wrap flex-sm-nowrap gap-5 mt-6">
                                        <div>
                                            <img src="images/support-overload.webp" alt="" />
                                        </div>
                                        <div>
                                            <p>Support experts generally spend a lot of time answering queries. This not only slows replies but also takes opportunities away from visitor interactions.</p>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-6">
                            <div className="card service-card-item shadow-sm rounded-3 h-100 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                                <div className="card-body px-md-7 py-md-8">
                                    <h6>Customer Frustration</h6>
                                    <div className="d-flex flex-wrap flex-sm-nowrap gap-5 mt-6">
                                        <div>
                                            <img src="images/customer-frustration.webp" alt="" />
                                        </div>
                                        <div>
                                            <p>Long wait times and unresolved queries instantly irritate visitors. When clients feel ignored, their whole trust in your business starts to vanish.</p>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 col-xl-6">
                            <div className="card service-card-item shadow-sm rounded-3 h-100 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                                <div className="card-body px-md-7 py-md-8">
                                    <h6>Missed Conversations</h6>
                                    <div className="d-flex flex-wrap flex-sm-nowrap gap-5 mt-6">
                                        <div>
                                            <img src="images/missed-conversations.webp" alt="" />
                                        </div>
                                        <div>
                                            <p>Most of the clients come ready to ask queries or check out services. Without a chatbot leading the interaction, those discussions never really start.</p>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            <div className="brand-section-1 bg-dark">
                <div className="container pt-100 pb-100">
                    <div className="row justify-content-center">
                        <div className="col-xxl-7 col-xl-8">
                            <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                <div className="w-2 h-2 rounded-circle bg-primary"></div>
                                <small className="text-primary fw-bold">Yes!! No More Delays.</small>
                            </div>
                            <div className="text-center mb-8">
                                <h2 className="text-white mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">24/7 Customer Support Without Any “Please Wait” Moment</h2>
                                <p className="text-white mb-0 max-text-56 mx-auto sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Visitors want solutions just now, not five or seven minutes later. An AI chatbot always keeps the responses coming instantly-no interruptions, just constant support.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row g-4">
                        <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <div className="bg-white bg-opacity-5 p-6 p-xl-10 rounded-3">
                                <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                                    <h5 className="text-white mb-0">Want Smooth Discussions?</h5>
                                    <p className="h5 mb-0 text-white text-opacity-25">01</p>
                                </div>
                                <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                                    <div className="flex-shrink-0">
                                        <img src="/images/smooth-discussions.webp" alt="icon" className="img-fluid"/>
                                    </div>
                                    <div>
                                        <p className="text-white mb-4">The AI-based chatbot always keeps the conversation flowing seamlessly, so all users stay fully engaged rather than leaving while waiting during serious conversations.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                            <div className="bg-white bg-opacity-5 p-6 rounded-3 p-xl-10">
                                <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                                    <h5 className="text-white mb-0">Want an Instant Reply?</h5>
                                    <p className="h5 mb-0 text-white text-opacity-25">02</p>
                                </div>
                                <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                                    <div className="flex-shrink-0">
                                        <img src="/images/instant-reply.webp" alt="icon" className="img-fluid"/>
                                    </div>
                                    <div>
                                        <p className="text-white mb-4">Whether it’s early morning, midnight, or anytime in between, clients always wish to get an instant reply. The moment they get the solutions to their queries, they trust you & visit more.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section className="pt-60 pb-100 position-relative">
        <div className="container">
            <div className="row g-4">
                <div className="col-lg-5 mb-lg-0 mb-5">
                    <div className="position-sticky start-0 top-20">
                      <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>AI in Action</small>
                        <h2 className="max-text-20 ff-sg mb-4">So, What’s Really Powering All These Modern Conversations?</h2>
                        <p className="max-text-44 mb-8">Ever think about how the chatbot knows about questions instantly? Or how it responds quickly without missing the context? That’s where AI works silently behind the scenes.</p>
                    </div>
                </div>
                <div className="col-lg-7">
                    <div className="row g-4">
                        <div className="col-md-6">
                            <div className="blog_11_item bg-blue p-6 rounded-3 border border-white border-opacity-10 h-100">
                                <div className="overflow-hidden rounded-4 mb-4">
                                    <img src="images/mistral.webp" alt="Image" className="img-fluid" />
                                </div>
                                    <h3 className="text-white fs-20 mb-6">Mistral-7B-v0.1</h3>
                                <p className="dark-card-p-color">Lightweight AI-based chatbots that accept your commands and reply instantly while keeping the discussion in context.</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="blog_11_item bg-dark-11 p-6 rounded-3 border border-white border-opacity-10 h-100">
                                <div className="overflow-hidden rounded-4 mb-4">
                                    <img src="images/gemma.webp" alt="Image" className="img-fluid" />
                                </div>
                                    <h3 className="text-white fs-20 mb-6">Gemma 7B</h3>

                                <p className="dark-card-p-color">An advanced AI-based chatbot engineered especially to guide in different fields like research, education, and more.</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="blog_11_item bg-dark-11 p-6 rounded-3 border border-white border-opacity-10 h-100">
                                <div className="overflow-hidden rounded-4 mb-4">
                                    <img src="images/full-access-happy.webp" alt="Image" className="img-fluid" />
                                </div>
                                    <h3 className="text-white fs-20 mb-6">Llama 3.1 405B Instruct</h3>
                                <p className="dark-card-p-color">An AI-based chatbot developed for logic discovery, multilingual communication, reasoning, and more.</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="blog_11_item bg-blue p-6 rounded-3 border border-white border-opacity-10 h-100">
                                <div className="overflow-hidden rounded-4 mb-4">
                                    <img src="images/deepseek.webp" alt="Image" className="img-fluid" />
                                </div>
                                    <h3 className="text-white fs-20 mb-6">DeepSeek R1 Distill Llama 70B</h3>
                                <p className="dark-card-p-color">An advanced AI assistant crafted for legal, medical, and academic research, offering accurate insights and reasoning.</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="blog_11_item bg-blue p-6 rounded-3 border border-white border-opacity-10 h-100">
                                <div className="overflow-hidden rounded-4 mb-4">
                                    <img src="images/your-location.webp" alt="Image" className="img-fluid" />
                                </div>
                                    <h3 className="text-white fs-20 mb-6">Llama 3.3 70B Instruct</h3>
                                <p className="dark-card-p-color">Modern AI is engineered for expert-level writing, thorough research guidance, and advanced business analytics.</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="blog_11_item bg-dark-11 p-6 rounded-3 border border-white border-opacity-10 h-100">
                                <div className="overflow-hidden rounded-4 mb-4">
                                    <img src="images/one-tap-installation.webp" alt="Image" className="img-fluid" />
                                </div>
                                    <h3 className="text-white fs-20 mb-6">Llama-3.1-Nemotron-70B-Instruct</h3>
                                <p className="dark-card-p-color">Instruction-based AI model crafted for performing reasoning, offering guidance, and advanced NLP tasks.</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="blog_11_item bg-dark-11 p-6 rounded-3 border border-white border-opacity-10 h-100">
                                <div className="overflow-hidden rounded-4 mb-4">
                                    <img src="images/openchat.webp" alt="Image" className="img-fluid" />
                                </div>
                                    <h3 className="text-white fs-20 mb-6">OpenChat 3.5 0106</h3>
                                <p className="dark-card-p-color">An open-source GPT-4 alternative designed for advanced coding, brainstorming, and challenging reasoning.</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="blog_11_item bg-blue p-6 rounded-3 border border-white border-opacity-10 h-100">
                                <div className="overflow-hidden rounded-4 mb-4">
                                    <img src="images/deepseek.webp" alt="Image" className="img-fluid" />
                                </div>
                                    <h3 className="text-white fs-20 mb-6">DeepSeek R1</h3>
                                <p className="dark-card-p-color">A general-level chatbot AI proficient in managing research, translation, and challenging document insight.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>

            <section className="pb-60">
                <div className="container">
                    <div className="bg-white px-8 py-10 rounded-3">
                        <div className="row align-items-center g-4">
                            <div className="col-lg-5">
                                <img src="/images/chatbot-benefits.webp" alt="image" className="img-fluid sal-animate" data-sal="fade" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine"/>
                            </div>
                            <div className="col-lg-7">
                                <div className="d-inline-flex align-items-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                    <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded">
                                    <span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Chatbot Benefits!!
                                    </small>
                                </div>
                                <h2 className="mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">What Can a Chatbot Online Really Do for You?</h2>
                                <p className="mb-0 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Umm… Ever think that what if your site could answer everyone's queries in seconds? That’s truly what a chatbot is engineered for. It simply replies to all users in real time, assists them, and keeps all discussions flowing without interruptions-which makes every single interaction feel instant and valuable.</p>
                            </div>
                        </div>
                    </div>
                    <div className="container pt-10">
                    <div className="row g-4">
                        <div className="col-sm-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <div className="card h-100">
                                <div className="card-body p-xl-8">
                                    <div className="hstack gap-3 mb-4">
                                        <span className="d-inline-block flex-shrink-0">
                                            <img src="/images/always-awake.webp" alt="image" className="img-fluid" />
                                        </span>
                                        <h6 className="mb-0 flex-grow-1">
                                            Umm… Always Awake
                                        </h6>
                                    </div>
                                    <p className="mb-0">
                                        Visitors don’t always visit most at the time of working hours. Your chatbot remains highly active 24/7, all set to answer different queries and guide clients whenever they arrive.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                            <div className="card h-100">
                                <div className="card-body p-xl-8">
                                    <div className="hstack gap-3 mb-4">
                                        <span className="d-inline-block flex-shrink-0">
                                            <img src="/images/instant-conversations.webp" alt="image" className="img-fluid" />
                                        </span>
                                        <h6 className="mb-0 flex-grow-1">
                                            Instant Conversations
                                        </h6>
                                    </div>
                                    <p className="mb-0">
                                        A chatbot online replies the moment users start asking their queries, turning all simple clicks into real-time discussions that move smoothly without any type of interruption or delay.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                            <div className="card h-100">
                                <div className="card-body p-xl-8">
                                    <div className="hstack gap-3 mb-4">
                                        <span className="d-inline-block flex-shrink-0">
                                            <img src="/images/lead-moments.webp" alt="image" className="img-fluid" />
                                        </span>
                                        <h6 className="mb-0 flex-grow-1">
                                            Lead Moments
                                        </h6>
                                    </div>
                                    <p className="mb-0">
                                        Every conversation is basically a chance to gain more visitors and engage them. The chatbot generally gathers users' details while chatting, and helps turn interest into quality leads.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <div className="card h-100">
                                <div className="card-body p-xl-8">
                                    <div className="hstack gap-3 mb-4">
                                        <span className="d-inline-block flex-shrink-0">
                                            <img src="/images/guided-journeys.webp" alt="image" className="img-fluid" />
                                        </span>
                                        <h6 className="mb-0 flex-grow-1">
                                            Guided Journeys
                                        </h6>
                                    </div>
                                    <p className="mb-0">
                                        Users usually need the right direction. A chatbot always helps them to check out different services, find desired solutions, and move through the website in more detail.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                            <div className="card h-100">
                                <div className="card-body p-xl-8">
                                    <div className="hstack gap-3 mb-4">
                                        <span className="d-inline-block flex-shrink-0">
                                            <img src="/images/less-repetition.webp" alt="image" className="img-fluid" />
                                        </span>
                                        <h6 className="mb-0 flex-grow-1">
                                            Less Repetition
                                        </h6>
                                    </div>
                                    <p className="mb-0">
                                        Rather than answering the same queries again and again, the chatbot online manages basic-level queries in no time, freeing your experts to focus only on further conversations.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                            <div className="card h-100">
                                <div className="card-body p-xl-8">
                                    <div className="hstack gap-3 mb-4">
                                        <span className="d-inline-block flex-shrink-0">
                                            <img src="/images/powerful-engagement.webp" alt="image" className="img-fluid" />
                                        </span>
                                        <h6 className="mb-0 flex-grow-1">
                                            Powerful Engagement
                                        </h6>
                                    </div>
                                    <p className="mb-0">
                                        Instant replies always make users feel heard and fully supported. With the help of a chatbot online, discussions stay active, helping all visitors to explore more and stay a bit longer.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>

            </section>

            <div className="pb-100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-10 col-lg-8 col-xl-6">
                            <div className="text-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Wanna Chat?</small>
                                <h2 className="mb-4">
                                    Let’s Make All Your Discussions Smooth 
                                </h2>
                                <p className="mb-8 max-text-52 mx-auto sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                    Don’t let your doubts go ignored. Our chatbot always keeps every user supported, 24/7.
                                </p>
                                <div className="d-flex flex-wrap justify-content-center align-items-center gap-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                    <Link to="/contact-us" className="btn btn-lg btn-primary btn-arrow fs-14 fw-medium rounded btn-height">
                                        <span className="d-inline-block me-1 flex-shrink-0">
                                            <i className="las la-comment-dots"></i>
                                        </span>
                                        <span className="btn-arrow__text">
                                            Contact Us
                                            <span className="btn-arrow__icon">
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </span>
                                        </span>
                                    </Link>
                                    <Link to="#" className="btn btn-lg btn-dark btn-arrow fs-14 fw-medium rounded open-live-chat btn-height">
                                        <span className="d-inline-block me-1 flex-shrink-0">
                                            <i className="las la-comment-dots"></i>
                                        </span>
                                        <span className="btn-arrow__text">
                                            Talk to an Expert
                                            <span className="btn-arrow__icon">
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </span>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}